import { createSlice } from "@reduxjs/toolkit";
import createStripePortalSession from "@custom/rtk-apis/payement-gateway/createStripeSession";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const createStripePortalSessionSlice = createSlice({
  name: "createStripePortalSessionSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(createStripePortalSession.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(createStripePortalSession.fulfilled, (state, { payload }) => {
        console.log("Fulfilled ",payload)
        state.loading = false;
        state.status = '201';
        state.result = payload;
        state.error=''
      })
      .addCase(createStripePortalSession.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
        state.error = 'Something went wrong!'
      });
  },
});

export default createStripePortalSessionSlice.reducer;
